import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-white px-5 py-12 sm:py-16" data-id="element-17" data-mp="gwx3kxxwuxbm">
      <div className="mx-auto max-w-[680px]" data-id="element-18" data-mp="vtfjgwgyi5h2">
        <h2 className="flex items-center justify-center gap-2.5 text-center text-[1.5rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[1.9rem]" data-id="element-19" data-mp="vu7g8amai98x">
          <GiftIcon className="h-6 w-6 shrink-0 text-orange-700" aria-hidden="true" data-id="element-20" data-mp="14s9n36spfw44" />
          PLUS: 5 Strategic Bonuses Included
        </h2>

        <ol className="mt-7 divide-y divide-orange-500/30 rounded-lg border-2 border-dashed border-orange-500/70 bg-slate-100" data-id="element-21" data-mp="1ejnhx19po7qx">
          {bonuses.map(bonus => <li key={bonus.label} className="flex gap-4 px-5 py-4" data-id="element-22" data-mp="19mndsvwf9f2g">
              <span className="w-[4.5rem] shrink-0 pt-0.5 text-[0.75rem] font-black uppercase tracking-[0.14em] text-orange-700" data-id="element-23" data-mp="1nklqlwv3h3fu">
                {bonus.label}
              </span>
              <div data-id="element-24" data-mp="3prn5hzw17d3u">
                <h3 className="text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950" data-id="element-25" data-mp="3ps4z0orb7d82">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[0.95rem] leading-snug text-slate-800" data-id="element-26" data-mp="2kkscrzdrg05">
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}